module.exports = __webpack_public_path__ + "media/images/ico_expe-ee410034be97574a78e4f926bbeb3127.svg";